export const ListRouting = [
  {
    hidden: true,
    path: "/dashboard/list/enterpriseAnnouncement",
    name: "dashboard-list-enterpriseAnnouncement",
    meta: { title: "企业公告" },
    component: () =>
      import(
        /* webpackChunkName: "tender-apply" */ "@/views/dashboard/list/enterpriseAnnouncement/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/dashboard/list/rulesAndRegulations",
    name: "dashboard-list-rulesAndRegulations",
    meta: { title: "规章制度" },
    component: () =>
      import(
        /* webpackChunkName: "tender-apply" */ "@/views/dashboard/list/rulesAndRegulations/index.vue"
      ),
  },
];
